import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, Box, Button, Image, MenuButton, Paragraph, Spinner, Text, useColorMode } from "theme-ui";
import { GetTimeByStageId, getAllSubtasksOfSameTask, getHistoryByView } from "../../../store/actions/project.action";
import activity from "../../assets/images/Icon/activity.svg";
import spent from "../../assets/images/Icon/spent.svg";
import StageActions from "./StageActions";
import { useNavigate, useParams } from "react-router-dom";
import ThreadModalPop from "../../ThreadModalPop/ThreadModalPop";
import deleteIcon from "../../assets/images/Icon/delete.svg";
import { AllActivities, getUserName } from "../../../utils/activityHistoryHelper";
import { bucketUrl } from "../../../utils/global";
import HistoryAction from "../../project-components/HistoryAction";
import { ActivityHistoryItem, RootState, SpentTimeItem, StageSideActionsProps } from "../../../../@types";
import UpdateStatusToAny from "../../Actions/UpdateStatusToAny";
import { stageStatuslist } from "../../../utils/constent";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { deleteStage } from "../../../store/actions/masterData.action";
import { deleteStageByIdApi } from "../../../store/api";
import { checkDeletionPermission } from "../../../utils/GenerateQueryString";
import toast from 'react-hot-toast';
import theme from "../../../theme";
import TaskView from '../../assets/images/TaskView.svg';
import PrelimTaskModal from "../TaskView/PrelimTaskModal";
import InfiniteScroll from "react-infinite-scroll-component";
import ActivityHistoryModal from "../demotable/ActivityHistoryModal";
import ActivityRevertHistory from "../demotable/ActivityRevertHistory";

const StageSideActions: React.FC<StageSideActionsProps> = ({ isTracking, elapsedTime, timeTaken, threads }) => {
    const { auther } = useSelector((state: RootState) => state.auth);
    const { stageId } = useParams<{ stageId: string }>();
    const { dataForTable } = useSelector((state: RootState) => state.masterData);
    const { historyView, spentTime, stagesView, historyLoader } = useSelector((state: RootState) => state.project);
    const [showAll, setShowAll] = useState(false);
    const [items, setItems] = useState<ActivityHistoryItem[]>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const lastFetchRef = useRef("");
    const fetchingRef = useRef("");
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const limit = 25;
    const is_Super_Admin = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "super admin");
    const is_Project_Manager = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "project manager");
    const is_Project_Worker = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "project worker");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [stageConfirmMessage, setStageConfirmMessage] = useState<string>('');
    const [taskmodalOpen, setIsTaskModalOpen] = useState<boolean>(false);
    const projectId = stagesView?.projectId;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState('activity');
    const [historyModalOpen, setHistoryModalOpen] = useState<boolean>(false);

    const handleTabClick = (tab: string) => {
        const wasAlreadyActive = tab === 'activity' && selectedTab === 'activity';
        setSelectedTab(tab);
        if (tab === 'activity') {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
            if (wasAlreadyActive) {
                const currentPayload = `stageId=${stageId}&page=1&limit=${limit}`;
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
                dispatch(getHistoryByView(currentPayload));
            }
        }
    };

    useEffect(() => {
        setPageNumber(1);
        setItems([]);
        setHasMore(true);
        fetchingRef.current = "";
        lastFetchRef.current = "";
    }, [stageId]);

    useEffect(() => {
        if (historyView === null) {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
        }
    }, [historyView === null]);

    useEffect(() => {
        const currentPayload = `stageId=${stageId}&page=${pageNumber}&limit=${limit}`;
        if (selectedTab === 'activity' && currentPayload !== fetchingRef.current) {
            if (currentPayload !== lastFetchRef.current || historyView === null) {
                dispatch(getHistoryByView(currentPayload));
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
            }
        }
    }, [dispatch, pageNumber, stageId, selectedTab]);

    useEffect(() => {
        if (historyView?.data && !historyLoader) {
            fetchingRef.current = ""; // Reset fetching ref on success
            if (pageNumber === 1) {
                setItems(historyView?.data);
            } else {
                setItems((prevItems) => [...prevItems, ...historyView?.data]);
            }

            if (historyView?.count !== undefined) {
                setTotalItems(historyView?.count);
            }

            if ((historyView?.data?.length || 0) < limit) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
        }
    }, [historyView?.data, pageNumber, stageId, historyLoader]);

    const fetchMoreData = () => {
        if (!hasMore || items?.length >= totalItems || historyLoader) {
            return;
        }
        const nextPage = pageNumber + 1;
        setPageNumber(nextPage);
    };
    useEffect(() => {
        dispatch(GetTimeByStageId(stageId));
    }, [dispatch, stageId])
    useEffect(() => {
        if (isTracking) {
            setSelectedTab('spent');
        }
    }, [isTracking]);

    const handleSubtaskTabClick = (tab: string) => {
        setSelectedTab(tab);

    };
    useEffect(() => {
        if (selectedTab === 'Other Subtasks') {
            if (stagesView?.projectId?._id && stagesView?._id) {
                const actionObject = {
                    projectId: stagesView.projectId._id,
                    stageId: stagesView._id,
                };
                dispatch(getAllSubtasksOfSameTask(actionObject));
            }
            toggleModal();
        }
    }, [selectedTab, dispatch])
    const toggleModal = () => {
        setIsTaskModalOpen(!taskmodalOpen);

    };
    function convertMillisecondsToHoursMinutesSeconds(milliseconds: number) {
        let seconds = Math.floor(milliseconds / 1000);
        const days = Math.floor(seconds / 86400);
        seconds %= 86400;
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
        return { days, hours, minutes, seconds };
    }


    const [isInitialConfirm, setIsInitialConfirm] = useState<boolean>(true);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const handleDeleteStage = () => {
        if (!stageId) return;
        const userRoles = auther?.Role || [];
        const checkResult = checkDeletionPermission(stagesView, userRoles, 'stage');

        if (!checkResult.allowed) {
            toast.error(checkResult.message);
            return;
        }

        setStageConfirmMessage(checkResult.message);
        setIsInitialConfirm(true);
        setShowConfirmation(true);
    };

    const confirmDeleteStage = () => {
        if (isDeleting || !stageId) return;
        setIsDeleting(true);
        const targetProjId = stagesView?.projectId?._id || stagesView?.projectId || (typeof projectId === 'object' ? (projectId as any)?._id : projectId);

        deleteStageByIdApi(stageId, true).then(() => {
            setIsDeleting(false);
            dispatch(deleteStage(stageId));
            setShowConfirmation(false);
            if (targetProjId) {
                navigate(`/create-project?step=2&id=${targetProjId}`);
            }
        }).catch(() => {
            setIsDeleting(false);
            setShowConfirmation(false);
        });
    };

    const cancelDeleteStage = () => {
        if (isDeleting) return;
        setShowConfirmation(false);
    };
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const modalHeader = colorMode === 'light' ? "#f6f6f6" : "#20283c";

    const toggleActivityModal = () => setModalOpen(!modalOpen);
    const toggleHistoryModal = () => setHistoryModalOpen(!historyModalOpen);
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={cancelDeleteStage}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );

    const getUserProfileIcon = (firstName: string, lastName: string) => {
        const firstLetter = firstName.charAt(0).toUpperCase();
        const lastLetter = lastName.charAt(0).toUpperCase();
        return <div style={{
            backgroundColor: "#7743DB",
            color: "#fff",
            width: '50px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {firstLetter.charAt(0).toUpperCase()}{lastLetter.charAt(0).toUpperCase()}
        </div>
    }
    return (
        <>
            <div className='col-md-3 p-3' style={{ maxHeight: "750px", borderLeft: `2px solid ${theme?.colors?.lightbackground}`, overflowY: "auto" }} >
                {selectedTab === 'activity' && (
                    <>
                        <div>
                            <h5>Activity</h5>
                            <p style={{ color: titleHeader }}>All Activities</p>
                        </div>
                        <div>
                            {items?.length === 0 && historyLoader ? (
                                <Box sx={{ textAlign: 'center', mt: 4 }}>
                                    <Spinner />
                                </Box>
                            ) : (
                                <InfiniteScroll
                                    dataLength={items?.length || 0}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<Box sx={{ textAlign: "center" }}><Spinner /></Box>}
                                    height={550}
                                    endMessage={<p ></p>}

                                >
                                    {(() => {
                                        const seenTexts = new Set<string>();
                                        return items?.map((history: ActivityHistoryItem, historyIndex: number) => {
                                            const activityText = AllActivities(
                                                history?.action || '',
                                                history?.changes ? { ...history?.changes, stageId: history?.stageId || history?.changes?.stageId, taskId: history?.taskId || history?.changes?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.changes),
                                                history?.oldData ? { ...history?.oldData, stageId: history?.stageId || history?.oldData?.stageId, taskId: history?.taskId || history?.oldData?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.oldData),
                                                dataForTable?.data?.allProjectManagers, dataForTable?.data?.allTaskManagers, dataForTable?.data?.allProjectWorkers, dataForTable?.data?.allTaskWorkers, dataForTable?.data?.allHighlighters, dataForTable?.data?.allArchitects, false, dataForTable?.data?.allStages, dataForTable?.data?.allTask?.data || dataForTable?.data?.allTask || dataForTable?.data?.allTasks);
                                            if (!activityText) return null;
                                            const timeKey = history?.createdAt ? moment(history.createdAt).format('YYYY-MM-DD-HH:mm') : historyIndex;
                                            const normalized = `${timeKey}_${activityText.toLowerCase().replace(/['"\s_-]/g, '')}`;
                                            if (seenTexts.has(normalized)) return null;
                                            seenTexts.add(normalized);
                                            return (
                                                <div key={historyIndex + 1} style={{ flexWrap: 'wrap' }}>
                                                    <Paragraph style={{ gap: 2, marginRight: '5px' }} variant="activityText">
                                                        <strong style={{ marginRight: '6px' }}>{getUserName(history?.changes?.updatedBy || history?.changes?.updateObject?.updatedBy || history?.changes?.createdBy || history?.updatedBy || history?.createdBy, dataForTable?.data)}</strong>
                                                        {' '}{activityText}
                                                    </Paragraph>
                                                    <Paragraph sx={{ textAlign: "end", fontSize: "10px", color: "#D3D5D9", marginBottom: "0px" }}>{moment(history?.createdAt).format('MMM DD, LT')}</Paragraph ></div>);
                                        });
                                    })()}
                                </InfiniteScroll>
                            )}
                        </div>
                    </>
                )}
                {selectedTab === 'thread' && (
                    <div>
                        <h5>Chat section</h5>
                        <p className='text-muted'>All Chats</p>
                    </div>
                )}
                {selectedTab === 'spent' && (
                    <>
                        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                            <div className="text-center">
                                <h5>Time Tracking</h5>
                                <p style={{ color: titleHeader }}>Spend history</p>
                            </div>
                            <MenuButton aria-label="Toggle Menu" />
                        </div>
                        <div className="text-center">
                            {isTracking !== null && <>
                                <p>Tracking Started</p>
                                <h1>{elapsedTime}</h1>
                            </>
                            }
                        </div>
                        <hr />

                        <div className="container-fluid">
                            <div className="row mb-4">
                                <div className="col-md-8"><h5>Last Actions<Badge variant='circle' mt={-3}>{spentTime?.length}</Badge></h5></div>
                                <div className="col-md-4">
                                    {spentTime.length > 5 && (
                                        <div>
                                            {showAll ? (
                                                <Button variant="spentButton" onClick={() => setShowAll(false)}>Show Less</Button>
                                            ) : (
                                                <Button variant="spentButton" onClick={() => setShowAll(true)}>Show All</Button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ maxHeight: '675px', overflow: 'auto' }}>
                                {showAll ? (
                                    spentTime?.filter((time: SpentTimeItem) => time?.timeTaken).map((time: SpentTimeItem, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken || 0);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";

                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {time?.userId?.ProfileImage ? <Avatar src={`${bucketUrl}${time?.userId?.ProfileImage}`} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName || '', time?.userId?.LastName || '')}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{time?.userId?.FirstName} {time?.userId?.LastName}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt).format('ll')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    spentTime?.filter((time: SpentTimeItem) => time?.timeTaken).slice(0, 5).map((time: SpentTimeItem, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken || 0);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";

                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {time?.userId?.ProfileImage ? <Avatar src={`${bucketUrl}${time?.userId?.ProfileImage}`} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName || '', time?.userId?.LastName || '')}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{time?.userId?.FirstName} {time?.userId?.LastName}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt).format('ll')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                        </div>
                    </>
                )}
                {selectedTab === 'action' && (
                    <div>
                        <h5>Actions</h5>
                        <p className='text-muted'>All Actions</p>
                    </div>
                )}
            </div>
            <ActivityHistoryModal
                isOpen={modalOpen}
                toggle={toggleActivityModal}
                items={items}
                hasMore={hasMore}
                fetchMoreData={fetchMoreData}
                dataForTable={dataForTable}
                colorMode={colorMode}
            />
            <ActivityRevertHistory isOpen={historyModalOpen} togglePopover={toggleHistoryModal} items={items}
                hasMore={hasMore}
                fetchMoreData={fetchMoreData}
                dataForTable={dataForTable}
                view="Stage"
                stageId={stageId}
                colorMode={colorMode}
            />
            <div className='text-center col-md-1 p-3' style={{ borderLeft: `2px solid ${theme?.colors?.lightbackground}` }}>
                <div onClick={() => handleTabClick('activity')}>
                    <button className='btn' style={{ backgroundColor: selectedTab === 'activity' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'activity' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={activity} alt='' style={{ fill: selectedTab === 'activity' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                </div>
                <Text className='mt-2' sx={{ cursor: 'pointer' }}>Activity</Text>

                <ThreadModalPop handleTabClick={handleTabClick} selectedTab={selectedTab} phaseId={stageId} level="stage" threads={threads} />
                <div onClick={() => handleTabClick('spent')} >
                    <button className='btn ' style={{ backgroundColor: selectedTab === 'spent' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'spent' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={spent} alt='' style={{ fill: selectedTab === 'spent' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                    <p className='mt-1' style={{ cursor: 'pointer' }}>Spent History</p>
                </div>
                <HistoryAction selectedTab={selectedTab} stageId={stageId} projectId={projectId?._id} view={"project-view"} />

                <StageActions selectedTab={selectedTab} stageId={stageId} />

                <>


                    <div onClick={() => handleSubtaskTabClick('Other Subtasks')}>
                        <button className='btn toggle-btn mt-3' >
                            <Image src={TaskView} alt='' />

                        </button>
                        <Box sx={{ color: titleHeader }}>Other Subtasks</Box>
                    </div>

                    <PrelimTaskModal isOpen={taskmodalOpen} toggle={toggleModal} projectId={stagesView?.projectId?._id} stageId={stagesView?._id} keys={{ first: "isDone", third: "isReviewed" }}
                    />
                </>
                {is_Super_Admin && <UpdateStatusToAny actionLists={stageStatuslist} levelStatus={"stage"} updateStatusId={stageId} keyName={"stageId"} stagesView={stagesView} />}
                {is_Project_Worker || is_Project_Manager || is_Super_Admin ? (
                    <Box sx={{ alignItems: 'center', cursor: 'pointer' }} className="mt-5">
                        <img src={deleteIcon} alt='Delete' onClick={handleDeleteStage} style={{ height: '25px', width: '25px' }} />
                    </Box>) : null}
            </div>
            <Modal isOpen={showConfirmation} toggle={cancelDeleteStage} size="sm" centered >
                <ModalHeader toggle={cancelDeleteStage} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }} >Confirm Deletion</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    {stageConfirmMessage || `Are you sure you want to delete ${stagesView?.temporaryName ? stagesView?.temporaryName : stagesView?.name} stage?`}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={cancelDeleteStage} disabled={isDeleting}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={confirmDeleteStage} disabled={isDeleting}>
                        {isDeleting ? <Spinner size={16} sx={{ color: '#fff' }} /> : 'Yes'}
                    </Button>
                </ModalFooter>

            </Modal>
        </>
    )
};
export default StageSideActions;
